














































































































import {Component, Prop, PropSync, Vue, Watch} from "vue-property-decorator";
import {IdMapper} from "@/interfaces/state/base";
import {ServiceFee} from "@/interfaces/entity";
import {deleteFeeOfPriceList, editFeeOfPriceList, listFeeOfPriceList} from "@/modules/pricelists/services";
import {ServiceFeeParams} from "@/modules/pricelists/params";
import {PaginationMeta} from "@/interfaces/common";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {ServiceFeeType} from "@/enums/type";
import debounce from "lodash/debounce";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import FreightFeeCodes from "@/modules/regions/FreightFeeCodes/index.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
    },
    {
        title: "Mã tính cước",
        dataIndex: "freightFeeCode",
        key: "freightFeeCode",
        scopedSlots: {customRender: "freightFeeCode"}
    },
    {
        title: "TL",
        dataIndex: "weight",
        key: "weight",
        scopedSlots: {customRender: "weight"}
    },
    {
        title: "Phí",
        dataIndex: "fee",
        key: "fee",
        scopedSlots: {customRender: "fee"}
    },
    {
        title: "Loại phí",
        dataIndex: "type",
        key: "type",
        scopedSlots: {customRender: "type"}
    },
    {
        title: "Thao tác",
        dataIndex: "id",
        key: "id",
        scopedSlots: {customRender: "action"},
        align: "center"
    }
];

@Component({
    name: "ManageFee",
    components: {FreightFeeCodes, EnumSelector, InputCurrency, ProvinceSelector}
})
export default class extends mixins(CommonMixin) {
    @Prop() priceListId!: number;
    @PropSync("visibleManageFee", {type: Boolean, default: false}) syncVisibleManageFee!: boolean;

    ServiceFeeType = ServiceFeeType;
    columns = columns;
    data: IdMapper<ServiceFee> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();

    cachedData = {};
    params = {
        search: undefined,
        freightFeeCode : undefined,
        type: undefined
    };

    private bodyStyle = {
        height: `80vh`,
        overflow: 'auto'
    };

    async created() {
        await this.listFee(new ServiceFeeParams());
    }

    get fees() {
        return this.ids.map((id: number) => this.data[id]);
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        const params = {...val, search: val.search || undefined, freightFeeCode : val.freightFeeCode };
        this.handleChangeParams(params);
    }

    handleChangeParams = debounce((params: any) => {
        this.listFee(params);
    }, 500);

    async listFee(params: any) {
        const {data} = await listFeeOfPriceList(this.priceListId, params);
        this.mapServiceFee(data);
    }

    async save(id: number) {
        const fee: ServiceFee = this.data[id];
        if (!fee) return;
        try {
            fee.isSaving = true;
            await editFeeOfPriceList(fee.id, fee);
            fee.editable = false;
            this.cachedData[id] = { ...fee };
            this.$message.success("Sửa phí thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa phí thất bại");
        }
        fee.isSaving = false;
        return;
    }

    edit(id: number) {
        const fee: any = this.data[id];
        if (!fee) return;
        fee.editable = true;
    }

    async deleteFee(id: number) {
        const fee: ServiceFee = this.data[id];
        if (!fee) return;
        fee.isDeleting = true;
        try {
            await deleteFeeOfPriceList(fee.id);
            this.ids.splice(this.ids.indexOf(fee.id), 1);
            delete this.data[fee.id];
            this.$message.success("Sửa phí thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa phí thất bại");
        }
        fee.isDeleting = false;
        return;
    }

    close(id: number) {
        let fee = this.data[id];
        if (!fee) return;
        fee = { ...fee, ...this.cachedData[id], ['editable']: false };
        this.data[id] = fee;
        console.log(this.cachedData[id]);
    }

    get pagination() {
        return {
            current: this.meta?.page,
            pageSize: this.meta?.limit,
            total: this.meta?.total,
            showTotal: (total: number) => `Tổng cộng ${total} phí`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        this.listFee({...{...this.params, search: this.params.search || undefined}, page: pagination.current});
    }

    mapServiceFee(data: any) {
        const idMapper = {};
        this.meta = data.meta;
        this.ids = data?.datas?.map((serviceFee: ServiceFee, index: number) => {
            idMapper[serviceFee.id] = {
                ...serviceFee,
                stt: index + 1,
                isDeleting: false,
                isSaving: false,
                editable: false
            };
            this.cachedData[serviceFee.id] = {
                ...serviceFee,
                stt: index + 1,
                isDeleting: false,
                isSaving: false,
                editable: false
            };
            return serviceFee.id;
        });
        this.data = idMapper;
    }
}
